import axios from 'axios';

export const getApiConfig = (apiName) => {

    const instance = axios.create({
        baseURL: window.portalBaseUrl
    });

    return instance.request({
        url: `/documentation/${apiName}/config.json`,
        method: 'GET'
    });
};

export const getStaticResource = (path) => {

    const instance = axios.create({
        baseURL: window.portalBaseUrl
    });

    return instance.request({
        url: `${path}`,
        method: 'GET'
    });
};